import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import home from '@/views/Home.vue'
import expertise from '@/views/Expertise.vue'
import achievements from '@/views/Achievements.vue'
import lawStories from '@/views/LawStories.vue'
import contact from '@/views/Contact.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: home
  },
  {
    path: '/תחומי-עיסוק',
    name: 'expertise',
    component: expertise
  },
  {
    path: '/הישגים-משפטיים',
    name: 'achievements',
    component: achievements
  },
  {
    path: '/טור-אישי',
    name: 'stroies',
    component: lawStories
  },
  {
    path: '/צור-קשר',
    name: 'contact',
    component: contact
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
